import { createAction } from '@reduxjs/toolkit';

export const RETRIEVE_CALL_ACTION_TYPE = 'saga/retrieveCall';
export const retrieveParkedAction = createAction(RETRIEVE_CALL_ACTION_TYPE);
